import { useHttp } from '../http'

export const useWorkoutCollectionHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`workout-collections/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`workout-collections`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`workout-collections`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`workout-collections/${id}`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`workout-collections/${id}`)
    }

    const photo = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().post(`workout-collections/${id}/photo`, payload)
    }

    // SSO-3651: sets library_hidden on every workout of the collection (admin_workout_management).
    const hideWorkouts = <T>(id: number): Promise<T> => {
        return useHttp().post(`workout-collections/${id}/hide-workouts`)
    }

    // The way back: clears library_hidden on the collection's workouts, AI-library sessions excepted.
    const showWorkouts = <T>(id: number): Promise<T> => {
        return useHttp().post(`workout-collections/${id}/show-workouts`)
    }

    return {
        find,
        get,
        create,
        update,
        del,
        photo,
        hideWorkouts,
        showWorkouts,
    }
}
